class VariantPanels extends HTMLElement {
  constructor() {
    super();
    this.targetId = this.dataset.targetId;
    
    if (!this.dataset.url || !this.dataset.sectionId || !this.targetId) return;

    this.baseUrl = this.dataset.url;
    this.sectionId = this.dataset.sectionId;
    this.cache = {}; 
    this.abortController = null;
  }

  connectedCallback() {
    this.setupUrlListener();
    const productInfo = this.closest('product-info') || document.querySelector('product-info');
    if (productInfo) {
      productInfo.addEventListener('change', (e) => {
        if (e.target.name === 'id') this.fetchData(e.target.value);
      });
    }
  }

  setupUrlListener() {
    let currentVariant = this.getVariantFromUrl();
    setInterval(() => {
      const newVariant = this.getVariantFromUrl();
      if (newVariant && newVariant !== currentVariant) {
        currentVariant = newVariant;
        this.fetchData(newVariant);
      }
    }, 500);
  }

  getVariantFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  async fetchData(variantId) {
    if (!variantId) return;

    if (this.cache[variantId]) {
      this.render(this.cache[variantId]);
      return;
    }

    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    try {
      const fetchUrl = `${this.baseUrl}?variant=${variantId}&section_id=${this.sectionId}`;
      
      const response = await fetch(fetchUrl, { signal: this.abortController.signal });
      if (!response.ok) throw new Error(response.status);

      const text = await response.text();
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(text, 'text/html');
      const newContent = htmlDoc.getElementById(this.targetId);

      if (newContent) {
        const htmlToRender = newContent.outerHTML;
        this.cache[variantId] = htmlToRender;
        this.render(htmlToRender);
      } else {
        const emptyHtml = `<div id="${this.targetId}"></div>`;
        this.cache[variantId] = emptyHtml;
        this.render(emptyHtml);
      }

    } catch (error) {
      if (error.name !== 'AbortError') console.error(error);
    }
  }

  render(html) {
    this.innerHTML = html;
  }
}

customElements.define('variant-panels', VariantPanels);